import { useCallback, useState } from "react";

export type PaymentModalState = {
	title: string;
	show: boolean;
};

export const usePaymentModal = () => {
	const [modalState, setModalState] = useState<PaymentModalState>({
		title: "Make A Payment",
		show: false,
	});

	const openModal = useCallback((title: string) => {
		setModalState({ title, show: true });
	}, []);

	const closeModal = useCallback(() => {
		setModalState((prev) => ({ ...prev, show: false }));
	}, []);

	const openLumpSumModal = useCallback(() => {
		openModal("Pay Lump Sum");
	}, [openModal]);

	const openSelectedModal = useCallback(() => {
		openModal("Pay Selected");
	}, [openModal]);

	return {
		modalState,
		openModal,
		closeModal,
		openLumpSumModal,
		openSelectedModal,
	};
};
